import { create } from 'zustand'
import { UserRole , User, UserAccessOrganization } from '../interface/user'

interface UserStore {
    user: User | null,
    roles: UserRole[],
    loading: boolean,
    isAdmin: boolean,
    isCompanyAdmin: boolean,
    setStore: (access: UserRole [], user: User) => void,
    setGdprSigned: () => void,
    resetStore: () => void
}

export const useUserStore = create<UserStore>()((set) => ({
    user: null,
    roles: [],
    loading: true,
    isAdmin: false,
    isCompanyAdmin: false,
    setStore: (roles : UserRole[], user: User) => set(() => ({ roles , user, loading: false, isAdmin: isAdmin(roles), isCompanyAdmin: isCompanyAdmin(roles) })),
    setGdprSigned: () => set((state) => ({ user: state.user ? { ...state.user, hasSignedGdpr: true } : null })),
    resetStore: () => {
        useUserOrganizationsStore.getState().resetStore();
        
        set(() => ({ 
            roles: [], 
            user: null, 
            loading: false,
            isAdmin: false
        }));
    }
}))
 
interface UserOrganizationsStore {
    organizations: UserAccessOrganization[],
    defaultOrg: UserAccessOrganization| null,
    setOrganizations: (item: UserAccessOrganization[]) => void,
    setDefaultOrganization: (item: UserAccessOrganization |null) => void,
    resetStore: () => void
}

export const useUserOrganizationsStore= create<UserOrganizationsStore>()((set) => ({
    defaultOrg: null,
    organizations:  [],
    setOrganizations: (organizations: UserAccessOrganization[]) => set(() => ({ organizations})),
    setDefaultOrganization: (defaultOrg: UserAccessOrganization | null ) => set(() => ({  defaultOrg})),
    resetStore: () => set(() => ({ organizations: [], defaultOrg: null }))
}))

const isAdmin = (roles: string[]) => {
	return roles.some(
	//	(role) => role === UserRole.Admin || role === UserRole.Firmaadministrator,
        (role) => role === UserRole.Admin,
	);
};

const isCompanyAdmin = (roles: string[]) => {
    return roles.some(
        (role) => role === UserRole.Firmaadministrator,
    );
};